import { z } from "zod";

export const updateEquipmentDeliveryFeeSchema = z.object({
  deliveryFeePriceHt: z.coerce.number().min(0, "Le prix doit être positif"),
  deliveryFeeVatRate: z.coerce.number(),
  freeDeliveryThresholdCents: z.coerce
    .number()
    .min(0, "Le seuil doit être positif")
    .nullable(),
});

export type UpdateEquipmentDeliveryFeeForm = z.infer<typeof updateEquipmentDeliveryFeeSchema>;

export const defaultUpdateEquipmentDeliveryFeeValues: UpdateEquipmentDeliveryFeeForm = {
  deliveryFeePriceHt: 10,
  deliveryFeeVatRate: 20,
  freeDeliveryThresholdCents: null,
};
